import { render, staticRenderFns } from "./VideoPlayerSix.vue?vue&type=template&id=87bc430a&"
import script from "./VideoPlayerSix.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerSix.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerSix.vue?vue&type=style&index=0&id=87bc430a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports